import React, { useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";

const DisableKeyboardNavigation = ({ enabled, children, className }) => {
	const rootRef = useRef();
	const alteredNodes = useRef([]);
	const overwrittenNodes = useRef([]);

	useLayoutEffect(() => {
		if (!enabled) {
			for (const item of overwrittenNodes.current) {
				const { child, tabindex } = item;
				child.setAttribute("tabindex", tabindex);
			}

			for (const child of alteredNodes.current) {
				child.removeAttribute("tabindex");
			}
		}
	}, [enabled]);

	useLayoutEffect(() => {
		if (rootRef.current) {
			const allChildren = rootRef.current.querySelectorAll("*");
			alteredNodes.current = [];
			overwrittenNodes.current = [];

			for (const child of allChildren) {
				const childTabIndex = child.getAttribute("tabindex");
				if (childTabIndex) {
					overwrittenNodes.current.push({
						child: child,
						tabindex: childTabIndex,
					});
				} else {
					alteredNodes.current.push(child);
				}

				child.setAttribute("tabindex", "-1");
			}
			alteredNodes.current = allChildren;
		}
	});

	if (!enabled) {
		return children;
	} else {
		return (
			<div ref={rootRef} className={className}>
				{children}
			</div>
		);
	}
};

export default DisableKeyboardNavigation;

DisableKeyboardNavigation.propTypes = {
	className: PropTypes.string,
	enabled: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
